/* eslint-disable react/prefer-stateless-function */
import React, { Fragment, Component } from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import PropTypes from 'prop-types'
// import NewsletterForm from '../NewsletterForm'
// import NewsletterFormMailchimp from '../NewsletterFormMailchimp'
import { Wrapper,
  List,
  Item,
  // SubFooterWrapper,
  // SubFooterContainer,
  Container } from './Footer.style'
import Image from '../../../shared/Image'

export const PureFooter = ({ allContentfulFooter }) => {
  const {
    // newsletterFormLabel,
    // subscribeButtonLabel,
    socialMedia,
    pageLinks,
    copyRightText,
  } = allContentfulFooter.edges[0].node

  return (
    <Fragment>
      {/* { newsletterFormLabel && subscribeButtonLabel && (
        <SubFooterWrapper>
          <SubFooterContainer>
            <NewsletterFormMailchimp
              formHeading={newsletterFormLabel}
              submitButtonLabel={subscribeButtonLabel}
            />
          </SubFooterContainer>
        </SubFooterWrapper>
      )} */}

      <Wrapper>
        <Container>
          <div className="leftLinks">
            <List>
              {socialMedia.map(item => {
                return (
                  <Item key={item.id}>
                    <a
                      href={item.url}
                      rel="nofollow noopener noreferrer"
                      target="_blank"
                    >
                      <Image src={item.imageFile.file.url} alt={item.altText} />
                    </a>
                  </Item>
                )
              })}
            </List>
          </div>
          <div className="rightLinks">
            <List>
              {pageLinks.length &&
              pageLinks.map(item => {
                return (
                  <Item key={item.id}>
                    <Link to={item.slug}>{item.title}</Link>
                  </Item>
                )
              })}
            </List>
            <div className="copyRightText">{copyRightText}</div>
          </div>
        </Container>
      </Wrapper>
    </Fragment>
  )
}

/* The block has to be rendered as a component otherwise typechecking isn't possible */
/* eslint-disable-next-line */
class Footer extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allContentfulFooter {
              edges {
                node {
                  newsletterFormLabel
                  subscribeButtonLabel
                  copyRightText
                  pageLinks {
                    id
                    title
                    slug
                  }
                  socialMedia {
                    id
                    url
                    altText
                    imageFile {
                      file {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        `}
        render={({ allContentfulFooter }) => {
          return (
            <PureFooter
              allContentfulFooter={allContentfulFooter}
            />
          )
        }}
      />
    )
  }
}

PureFooter.propTypes = {
  allContentfulFooter: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        socialMedia: PropTypes.array.isRequired,
        pageLinks: PropTypes.array.isRequired,
        copyRightText: PropTypes.string.isRequired,
        newsletterFormLabel: PropTypes.string.isRequired,
        subscribeButtonLabel: PropTypes.string.isRequired,
      }),
    })),
  }).isRequired,
}

export default Footer
